// ═══════════════════════════════════════════════════════════
// 详情弹窗
// ═══════════════════════════════════════════════════════════

export function openModal(title, contentHTML) {
    const modal = document.getElementById('modal');
    const modalTitle = document.getElementById('modalTitle');
    const modalContent = document.getElementById('modalContent');
    if (!modal || !modalTitle || !modalContent) return;

    modalTitle.textContent = title;
    modalContent.innerHTML = contentHTML;
    modal.classList.remove('hidden');
}

export function closeModal() {
    const modal = document.getElementById('modal');
    if (modal) {
        modal.classList.add('hidden');
        const content = document.getElementById('modalContent');
        if (content) content.innerHTML = '';
    }
}

// 全局暴露（供 HTML onclick 使用）
window.closeModal = closeModal;
